import React, {useState} from 'react';
import Spinner from "../Spinner";
import {concatenate} from "../../services/string";
import CountUp from "react-countup";

// Types ----

export type ProgressBarColour = "brand" | "gray" | "red" | "yellow" | "green"

export type ProgressBarProps = {
  title: string
  label?: string | null | false
  progress: number
  live?: boolean
  colour?: ProgressBarColour
};

// Helpers ----

const barColours: Record<ProgressBarColour, string> = {
  "brand": "bg-brand",
  "gray": "bg-gray-800",
  "red": "bg-red-700",
  "yellow": "bg-yellow-700",
  "green": "bg-green-700",
}

// Component ----

function ProgressBar({title, label, progress, live, colour = "brand"}: ProgressBarProps) {
  const [initialProgress] = useState<number>(progress);

  return (
    <div>
      <div className="mb-2 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          {live && (<Spinner color={Spinner.colors.DARK} size={Spinner.sizes.X_SMALL}/>)}
          <h3 className="text-sm font-semibold text-gray-600">{title}</h3>
        </div>

        <span className={concatenate("text-sm text-gray-600", !live && "font-semibold")}>
          {label? label : (
            <CountUp start={initialProgress} end={progress} suffix={"%"} decimals={1} preserveValue />
          )}
        </span>
      </div>

      <div
        className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden"
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={concatenate(
            "flex flex-col justify-center rounded-full overflow-hidden text-xs text-white text-center whitespace-nowrap transition-all duration-500",
            barColours[colour]
          )}
          style={{width: `${progress}%`}}
        />
      </div>
    </div>
  );
}

// Export ----

export default ProgressBar;